import { Chain } from '@ankr.com/chains-list';

import { AAPILinks } from './components/AAPILinks';
import { MultichainEndpoints } from './components/MultichainEndpoints';
import { useMultichainDetailsStyles } from './useMultichainDetailsStyles';

interface MultichainDetailsProps {
  Component: React.ElementType<{
    children: React.ReactNode;
    className?: string;
  }>;
  chain: Chain;
  children?: React.ReactNode;
  className?: string;
  hasEndpoints?: boolean;
  hasSupportedChainsLink?: boolean;
}

export const MultichainDetails = ({
  Component,
  chain,
  children,
  className,
  hasEndpoints,
  hasSupportedChainsLink,
}: MultichainDetailsProps) => {
  const { classes, cx } = useMultichainDetailsStyles();

  return (
    <Component className={cx(classes.root, className)}>
      {children}
      <AAPILinks hasSupportedChainsLink={hasSupportedChainsLink} />
      {hasEndpoints && <MultichainEndpoints chain={chain} />}
    </Component>
  );
};
